class PopUp {
  constructor() {
    console.log('>>> PopUp constructor');

    let popup = $('.js-popup');
        popup.modal('show');
  }
}

export default PopUp;
